/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {format, fromUnixTime, isSameDay, isSameWeek, isSameYear} from "date-fns";
import Tooltip from "../Tooltip.jsx";

class DisplayTime extends Component {


    constructor() {
        super();
        this.state = {
            currentTime: new Date()
        }
    }


    componentDidMount() {
        this.interval = setInterval(() => this.setState({currentTime: new Date()}), 2000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }


    timeSince(date) {
        let currentTime = this.state.currentTime
        if (isSameDay(currentTime, date)) {
            let seconds = Math.floor((new Date() - date) / 1000);

            let interval = seconds / 3600;
            if (interval > 1) {
                if (interval < 3) {
                    return Math.floor(interval) + " hours ago";
                } else {
                    return "at " + format(date, "HH:mm")
                }
            }
            interval = seconds / 60;
            if (interval > 1) {
                return Math.floor(interval) + " minutes ago";
            }
            return "Just now";
        } else if (isSameWeek(currentTime, date)) {
            return "this " + format(date, " eeee") + " at " + format(date, "HH:mm")
        } else if (isSameYear(currentTime, date)) {
            return "on " + format(date, " cccc dd. MMMM")
        } else {
            return "on " + format(date, " cccc dd. MMMM yyyy")
        }
    }


    render() {
        let {value} = this.props
        let dateValue = Math.floor(new Date(value).getTime() / 1000)

        if (Number.isNaN(Number.parseInt(dateValue))) {
            return (<div></div>)
        }

        value = fromUnixTime(dateValue)
        return (
            <>
                <Tooltip
                    text={
                        <div>{format(value, "cccc dd. MMMM yyyy HH:mm  (qqq) ")} (KW{format(value, "ww")})</div>}
                    delay={1000}
                >
                    <span className={"hover:text-gray-700"}>{this.timeSince(value)}  </span>
                </Tooltip>
            </>
        );
    }
}

DisplayTime.propTypes = {};

export default DisplayTime;